<script setup>
defineProps({
    msg: {
        type: String,
        required: true
    }
});

// Import the image (Vite will handle the asset)
import previewImg from '@/assets/images/preview.png?imagetools&format=webp&progressive';
import previewImg800 from '@/assets/images/preview.png?imagetools&format=webp&progressive&w=800';
import previewImg400 from '@/assets/images/preview.png?imagetools&format=webp&progressive&w=400';
import { RouterLink } from 'vue-router';
</script>

<template>
    <div class="greetings">
        <h1 class="orange">{{ msg }}</h1>

        <h2>Fast business card printing with delivery you control</h2>

        <nav>
            <RouterLink to="/">Home</RouterLink>
            <RouterLink to="/about">About</RouterLink>
        </nav>

        <div class="hero-image">
            <picture>
                <source :srcset="previewImg800" media="(min-width: 1024px)" />
                <source :srcset="previewImg400" media="(min-width: 600px)" />
                <img :src="previewImg" alt="Business card preview" />
            </picture>
        </div>
    </div>
</template>

<style scoped>
h1 {
    font-weight: 500;
    font-size: 2.6rem;
    position: relative;
    top: -10px;
}

h2 {
    font-size: 1.2rem;
}

.greetings h1,
.greetings h2 {
    text-align: center;
}

.hero-image {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
}

.hero-image img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

nav {
    width: 100%;
    font-size: 22px;
    text-align: center;
    margin-top: 2rem;
}

nav a.router-link-exact-active {
    color: var(--color-text);
}

nav a.router-link-exact-active:hover {
    background-color: transparent;
}

nav a {
    display: inline-block;
    padding: 0 1rem;
    border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
    border: 0;
}

@media (min-width: 1024px) {
    .greetings h1,
    .greetings h2 {
        text-align: left;
    }
    .hero-image {
        justify-content: flex-start;
    }
}
</style>
